import { Flex } from "@amzn/storm-ui";
import styled from "styled-components";

export const StyledText = styled(Flex)`
 display:flex;
 justify-content:center;
 margin-bottom:0.5rem;
 opacity:0.5;
`